// Instant local preview tile with a live progress bar while a photo uploads.
export function UploadingThumb({ up, className = "" }) {
  return (
    <div
      className={`relative aspect-square border border-zinc-300 dark:border-white/10 overflow-hidden bg-zinc-100 dark:bg-white/5 ${className}`}
      data-testid="uploading-thumb"
    >
      {up.url && <img src={up.url} alt="Uploading" className={`w-full h-full object-cover ${up.error ? "opacity-30" : "opacity-70"}`} />}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-black/35">
        {up.error ? (
          <span className="text-[9px] font-bold uppercase tracking-wider text-red-300">Failed</span>
        ) : (
          <>
            <span className="text-[10px] font-mono font-bold text-white drop-shadow">{up.pct}%</span>
            <div className="w-3/4 h-1 rounded-full bg-white/30 overflow-hidden">
              <div className="h-full bg-[#FF5F15] transition-all duration-200" style={{ width: `${up.pct}%` }} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
